import { Model } from '@vuex-orm/core'

export class User extends Model {
  static entity = 'users'
  static fields () {
    return {
      id: this.attr(null),
      name: this.attr(null),
      password: this.attr(null),
      organization: this.attr(null),
      department: this.attr(null),
      administrable: this.attr(null),
      roles: this.attr(null),
    }
  }
}
